const { createSlice } = require('@reduxjs/toolkit')

const initialState = {
  RoadmapBoard: []
}

const RoadmapSlice = createSlice({
  name: 'RoadmapSlice',
  initialState,
  reducers: {
    setRoadmapBoard: (state, action) => {
      state.RoadmapBoard = action.payload
    }
  }
})

export const { setRoadmapBoard } = RoadmapSlice.actions;
export default RoadmapSlice.reducer;



